import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { selectLoginEmail, setLoginEmail, setLoginError } from '../../../features/login/loginSlice';
import { isEmail } from '../../../utils/Validations';

export const LoginEmailInput: React.FC = () => {
  const email = useSelector(selectLoginEmail);
  const dispatch = useDispatch();

  return (
    <input
      className="hatters-input"
      name={'email'}
      type={'email'}
      placeholder="Email"
      autoComplete={'email'}
      value={email.email}
      onFocus={() => dispatch(setLoginError({ displayError: false, errorType: '' }))}
      onChange={(e) => dispatch(setLoginEmail({ email: e.target.value, isValid: isEmail(e.target.value) }))}
    />
  );
};
